import { ChatContextProvider } from "duck/ui/chat/contexts/ChatContextProvider";
import { Outlet } from "react-router";

import SecureComponent from "features/auth/Login/SecureComponent";
import { ToastContainer } from "features/ui/Toast/ToastContainer";

// This helps us wrap routes with ToastContainer so we can use react router components (ie. Link) inside Toasts
// ChatProvider is included here to ensure it's always inside Router context
const CommonRoutesWrapper = () => (
  <SecureComponent>
    <ToastContainer>
      <ChatContextProvider>
        <Outlet />
      </ChatContextProvider>
    </ToastContainer>
  </SecureComponent>
);

export default CommonRoutesWrapper;
